import { Box, Grid, Button, InputBase } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import Chip from "@mui/material/Chip";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import FormDialog from "components/modal";
import PaymentTypesForm from "../forms/paymentTypesForm";
import {requester} from "api/pesabackend";
import { setRefreshCount } from "state/authSlice";

import { useGetPaymentTypesList } from "api/hooks/billing";


export default function PaymentTypesTable () {
  
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);

  const {paymentTypesList, isLoadingPaymentTypesList} = useGetPaymentTypesList(1, business_branch_id)

  const categories = [
    {
        "name": "CASH",
        "id": 1
    },
    {
        "name": "MOBILE MONEY",
        "id": 2
    }
  ]

  const [name, setName] = useState("")
  const [description, setDescription] = useState("")
  const [category, setCategory] = useState("")
  const [isSubmittingPaymentType, setIsSubmittingPaymentType] = useState(false)
  const [open, setOpen] = useState(false);
  const[searchContent, setSearchContent] = useState("")

  const handleChangeName = (e) => {
    setName(e.target.value)
  }

  const handleChangeDescription = (e) => {
    setDescription(e.target.value)
  }

  const handleChangeCategory = (e) => {
    setCategory(e.target.value)
  }

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    // setModal("");
    setOpen(false);
  };

  const savePaymentType = async () => {
    setIsSubmittingPaymentType(true)
    const submitData = {
      "related_business": 1,
      "related_business_branch": business_branch_id,
      "payment_type_name": name,
      "payment_type_category": category,
      "description": description,
    }
    try {
      await requester.post("/billing/payment_types", submitData)
      setIsSubmittingPaymentType(false)
      dispatch(setRefreshCount())
      setOpen(false)
    }catch (err){
        setIsSubmittingPaymentType(false)
    }
  }

  const renderStatusPills = (status) => {
		switch (status) {
			case false:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffebeb", fontSize:"10px", fontWeight:700 }} label="INACTIVE" size="medium" color="warning" />;
			case true:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ebefff", fontSize:"10px", fontWeight:700 }} label="ACTIVE" size="medium" color="primary" />;
			default:
				return <Chip variant="outlined" sx={{ backgroundColor: "#ffeded", fontSize:"10px", fontWeight:700 }} label="CANCELLED" size="medium" color="danger" />;
		}
	};

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value)
  }
  
  return (
    <Box>
      <h3>Payment Types</h3>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <InputBase
            placeholder="Search by Account Name"
            value={searchContent}
            onChange={handleSearchInput}
            sx={{ ml: 1, flex: 1 }}
          />
          {/* <IconButton onClick={handleClickSearch}>
            <SearchIcon />
          </IconButton> */}

        <Button
          variant="contained"
          onClick={handleClickOpen}
        >
          CREATE PAYMENT TYPE
        </Button>
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Payment Type Name", width: 100 },
          { label: "Description", width: 100 },
          { label: "Created By", width: 50 },
          { label: "Status", width: 50 },
          { label: "Actions", align: "center", width: 150 },
        ]}
        rows={paymentTypesList}
        loading={isLoadingPaymentTypesList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.payment_type_name}</RCell>
            <RCell>{row.description}</RCell>
            <RCell>{`${row.created_by.first_name} ${row.created_by.last_name}`}</RCell>
            <RCell>{renderStatusPills(row.is_active)}</RCell>
            <RCell align="center">
              <Button
                value={row.id}
                size="small"
                onClick={(e) => navigate("/ledgerTransactions", { state: { id: row.id, name: row.payment_type_name }})}
              >
                View Details
              </Button>
            </RCell>
          </RRow>
        )}
      />

      <FormDialog
        open={open}
        handleClose={handleClose}
        enableActions={true}
        title={"Add New Payment Type"}
        buttonText="Create Payment Type" 
        handleSubmit={savePaymentType}
        isSubmitting={isSubmittingPaymentType}
        isSubmittingText={"Creating Payment Type, Please wait..."}
        textStatus={true}
        text={`Please note that this action is going to create a new ledger called ${name} under Cash and Bank`}
        content={
          <PaymentTypesForm
            handleChangeName={handleChangeName}
            handleChangeDescription={handleChangeDescription}
            handleChangeCategory={handleChangeCategory}
            category={category}
            categories={categories}
          />
        }
      />
    </Box>
  );
};
